import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name = '',
    keywords = '',
    summary = '',
    dType = '0',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.depCate.save, {
        id,
        name,
        keywords,
        summary,
        dType: dType + '',
    }, options);
    if (error) return { error, status };
    return content || {};
};
